import React, { useState, useEffect } from 'react';
import BookShelf from './BookShelf';
import Reader from './Reader';

function CoReading({ onBack, theme }) {
  const [selectedBook, setSelectedBook] = useState(null);

  // 进入共读系统时：隐藏 aizhi 底部导航栏
  useEffect(function() {
    // 方案：给 body 加 class，用 CSS 隐藏底部导航
    // 同时直接尝试隐藏常见的底部导航元素
    document.body.classList.add('co-reading-fullscreen');

    // 尝试隐藏 aizhi 的底部 tab 栏（多种选择器兜底）
    var navSelectors = [
      '.bottom-nav', '.tab-bar', '.app-nav', '.nav-bar',
      '[class*="bottomNav"]', '[class*="tabBar"]', '[class*="nav-container"]'
    ];
    var hiddenElements = [];
    navSelectors.forEach(function(sel) {
      var els = document.querySelectorAll(sel);
      els.forEach(function(el) {
        if (el && el.style.display !== 'none') {
          el.setAttribute('data-co-reading-hidden', 'true');
          el.style.setProperty('display', 'none', 'important');
          hiddenElements.push(el);
        }
      });
    });

    return function() {
      document.body.classList.remove('co-reading-fullscreen');
      // 恢复被隐藏的导航元素
      hiddenElements.forEach(function(el) {
        el.style.removeProperty('display');
        el.removeAttribute('data-co-reading-hidden');
      });
    };
  }, []);

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 9999,
      background: '#faf8f5',
      overflowY: 'auto',
      WebkitOverflowScrolling: 'touch'
    }}>
      {selectedBook ? (
        <Reader
          book={selectedBook}
          onBack={function() { setSelectedBook(null); }}
        />
      ) : (
        <BookShelf
          onSelectBook={setSelectedBook}
          onBack={onBack}
        />
      )}
    </div>
  );
}

export default CoReading;
